module.exports = __webpack_public_path__ + "static/media/baleia_minke.ff65ff87.png";